<template>
  <div class="cp-open mobile">

  </div>
</template>

<script>

export default {
  name: 'open',
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="stylus" scoped>
  .cp-open {
    position absolute
    width 6.4rem
    height 3.6rem
    background-size: 6.4rem 115.2rem;
    background-image url('./sprites3.png')
    background-repeat: no-repeat;
    background-position 0 0;
    animation: auto-circle 2.8s steps(31) infinite;
  }
  @keyframes auto-circle {
    to {
      background-position-y: -111.6rem;
    }
  }
</style>
